module.exports = __webpack_public_path__ + "static/media/ignoreaddemployee.21148e41.svg";